import { useMediaSearch } from "../../../hooks/useMediaSearch";
import { MediaSearchQuery } from "@jconradi/tutu-porn-api-client/src/media";
import { Spinner } from "../../Spinner/Spinner";
import { MediaListItem } from "./MediaListItem";
import cls from 'clsx';
import { OutstreamAd } from "../../Ads/Exoclick/OutstreamAd";
import useTranslation from "next-translate/useTranslation";
import { BuySpot } from "../../Ads/Tutu/BuySpot";
import { getTutuModelsUrl, TutuModelVideo } from "@jconradi/tutu-porn-components/services/api/tutu-models/tutu-models";
import { useRouter } from "next/router";
import { TutuMediaListItem } from "../../Ads/TutuModel/TutuMediaListItem";
import RandomSeed from 'seedrandom';
import React, { useId } from "react";
import { BannerAd } from "../../Ads/Exoclick/BannerAd";

export interface MediaListProps {
    query: MediaSearchQuery;
    loading: boolean;
    className?: string;
    tutuAds?: TutuModelVideo[];
}
export const MediaList = (props: MediaListProps) => {
    const mediaQuery = useMediaSearch(props.query, props.loading);
    const router = useRouter();
    const { t } = useTranslation('common')
    const id = useId();

    const rand = RandomSeed(id);
    return (
        <div className={cls(`flex-1 flex flex-col items-start gap-y-8`, props.className)}>
            {mediaQuery.isLoading &&
                <Spinner className="mx-auto" />
            }
            {mediaQuery.data?.totalMedia === 0 &&
                <p className="font-semibold mx-auto">{t('NoResultsFound')}</p>
            }
            {mediaQuery.data?.media.map((mediaListItem, idx) => {
                const tutuAds = props.tutuAds;
                const showTutuAd = mediaQuery.data.media.length > 7 ? (idx != 0 && idx % 7 == 0) : (idx == mediaQuery.data.media.length - 1)
                const showTutuModelAd = mediaQuery.data.media.length > 5 ? (idx != 0 && idx % 5 == 0) : (idx == mediaQuery.data.media.length - 1);
                const tutuAd = tutuAds ? tutuAds[Math.floor(rand() * tutuAds.length)] : undefined;

                return (
                    <React.Fragment key={mediaListItem.slug}>
                        {showTutuModelAd && props.tutuAds && <TutuMediaListItem video={tutuAd!} />}

                        {showTutuAd &&
                            <BuySpot key={`buy-spot-${idx}`} className="my-4 w-full" />
                        }
                        <MediaListItem key={mediaListItem.slug} mediaListItem={mediaListItem} />
                    </React.Fragment>
                )
            })}
        </div>
    )
}